module.exports = __webpack_public_path__ + "img/01.55c5621a.jpg";